/**
 * Stable "pin keys" for auto-laid nodes.
 *
 * autoLayout numbers its node ids sequentially (`battery-12`), so the
 * same symbol can come back under a different id after a structural
 * re-layout (toggle EXISTING, swap a model, add a battery). To carry a
 * user's hand-placed position across that regen we key nodes by what
 * they ARE rather than by id: symbol + topology ref + label, with an
 * occurrence index to separate siblings (two panel strings on the
 * same inverter, two DC isolators, ...). Deterministic for a given
 * topology, so a pin recorded before the regen matches after it.
 */
import type { SldNode } from '../store/editor';

export function computePinKeys(nodes: SldNode[]): Map<string, string> {
  const seen = new Map<string, number>();
  const out = new Map<string, string>();
  for (const n of nodes) {
    if (n.id === '__page_frame__' || n.id.startsWith('existing-boundary-')) continue;
    const d = n.data ?? ({} as SldNode['data']);
    const ref = d.topologyRef ? `${d.topologyRef.kind}:${d.topologyRef.id}` : '';
    const base = `${n.type ?? ''}|${d.symbolId ?? ''}|${ref}|${d.label ?? ''}`;
    const idx = seen.get(base) ?? 0;
    seen.set(base, idx + 1);
    out.set(n.id, `${base}#${idx}`);
  }
  return out;
}
